import { createContext, useEffect, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const ReportContext = createContext();

export const ReportContextProvider = ({ children }) => {
  let api = useAxiosPrivate();

  let [openReport, setOpenReport] = useState(false);
  let [admissionForReport, setadmissionForReport] = useState("all");
  let [programForReport, setProgramForReport] = useState("all");

  let [ownassignmentcourses, setownassignmentcourses] = useState({});
  let [reqassignmentcourses, setreqassignmentcourses] = useState({});
  let [otherDeptassignmentcourses, setotherDeptassignmentcourses] = useState(
    {}
  );
  let [loading, setLoading] = useState(true);
  let [showDetailsof, setshowDetailsof] = useState("own");

  let [dataOfGeneral, setDataOfGeneral] = useState({});

  async function getCourseReport(isMounted, signal) {
    try {
      let resp = await api.get("/courseallocation/report", {
        signal,
      });

      console.log(resp.data);

      isMounted && setownassignmentcourses(resp.data.ownassignment);
      isMounted && setreqassignmentcourses(resp.data.reqcourseassignment);
      isMounted && setotherDeptassignmentcourses(resp.data.otherdeptassignment);

      setLoading(false);
    } catch (err) {
      console.log("Erorrrr2");
      // setError()
    }
  }

  function filterReportResult() {
    let filteredOwnCourses = [];
    let filteredReqCourses = [];
    let filteredOtherCourses = [];

    let owntotal = 0;
    let reqtotal = 0;
    let othertotal = 0;

    let ownunassigned = 0;
    let requnassigned = 0;
    let otherunassigned = 0;

    if (admissionForReport === "all" && programForReport === "all") {
      owntotal = ownassignmentcourses.totalCoursesNumber;
      reqtotal = reqassignmentcourses.totalCoursesNumber;
      othertotal = otherDeptassignmentcourses.totalCoursesNumber;

      ownunassigned = ownassignmentcourses.unassignedCoursesNumber;
      requnassigned = reqassignmentcourses.unassignedCoursesNumber;
      otherunassigned = otherDeptassignmentcourses.unassignedCoursesNumber;
    } else {
      if (admissionForReport !== "all" && programForReport !== "all") {
        ownassignmentcourses.unassignedCourses.forEach((course) => {
          if (
            course.course_admission === admissionForReport &&
            course.course_program === programForReport
          ) {
            filteredOwnCourses.push(course);
          }
        });
        reqassignmentcourses.unassignedCourses.forEach((course) => {
          if (
            course.course_admission === admissionForReport &&
            course.course_program === programForReport
          ) {
            filteredReqCourses.push(course);
          }
        });
        otherDeptassignmentcourses.unassignedCourses.forEach((course) => {
          if (
            course.course_admission === admissionForReport &&
            course.course_program === programForReport
          ) {
            filteredOtherCourses.push(course);
          }
        });

        if (admissionForReport === "Regular" && programForReport === "UG") {
          ownassignmentcourses.combinationTotal.totalCourseNumberPerYearOfRegUg.forEach(
            (tot) => {
              owntotal += tot;
            }
          );
          reqassignmentcourses.combinationTotal.totalCourseNumberPerYearOfRegUg.forEach(
            (tot) => {
              reqtotal += tot;
            }
          );
          otherDeptassignmentcourses.combinationTotal.totalCourseNumberPerYearOfRegUg.forEach(
            (tot) => {
              othertotal += tot;
            }
          );
        } else if (
          admissionForReport === "Regular" &&
          programForReport === "Masters"
        ) {
          ownassignmentcourses.combinationTotal.totalCourseNumberPerYearOfRegMsc.forEach(
            (tot) => {
              owntotal += tot;
            }
          );
          reqassignmentcourses.combinationTotal.totalCourseNumberPerYearOfRegMsc.forEach(
            (tot) => {
              reqtotal += tot;
            }
          );
          otherDeptassignmentcourses.combinationTotal.totalCourseNumberPerYearOfRegMsc.forEach(
            (tot) => {
              othertotal += tot;
            }
          );
        } else if (
          admissionForReport === "Regular" &&
          programForReport === "Phd"
        ) {
          ownassignmentcourses.combinationTotal.totalCourseNumberPerYearOfRegPhd.forEach(
            (tot) => {
              owntotal += tot;
            }
          );
          reqassignmentcourses.combinationTotal.totalCourseNumberPerYearOfRegPhd.forEach(
            (tot) => {
              reqtotal += tot;
            }
          );
          otherDeptassignmentcourses.combinationTotal.totalCourseNumberPerYearOfRegPhd.forEach(
            (tot) => {
              othertotal += tot;
            }
          );
        } else if (
          admissionForReport === "Extension" &&
          programForReport === "UG"
        ) {
          ownassignmentcourses.combinationTotal.totalCourseNumberPerYearOfExtUg.forEach(
            (tot) => {
              owntotal += tot;
            }
          );
          reqassignmentcourses.combinationTotal.totalCourseNumberPerYearOfExtUg.forEach(
            (tot) => {
              reqtotal += tot;
            }
          );
          otherDeptassignmentcourses.combinationTotal.totalCourseNumberPerYearOfExtUg.forEach(
            (tot) => {
              othertotal += tot;
            }
          );
        } else if (
          admissionForReport === "Extension" &&
          programForReport === "Masters"
        ) {
          ownassignmentcourses.combinationTotal.totalCourseNumberPerYearOfExtMsc.forEach(
            (tot) => {
              owntotal += tot;
            }
          );
          reqassignmentcourses.combinationTotal.totalCourseNumberPerYearOfExtMsc.forEach(
            (tot) => {
              reqtotal += tot;
            }
          );
          otherDeptassignmentcourses.combinationTotal.totalCourseNumberPerYearOfExtMsc.forEach(
            (tot) => {
              othertotal += tot;
            }
          );
        } else if (
          admissionForReport === "Extension" &&
          programForReport === "Phd"
        ) {
          ownassignmentcourses.combinationTotal.totalCourseNumberPerYearOfExtPhd.forEach(
            (tot) => {
              owntotal += tot;
            }
          );
          reqassignmentcourses.combinationTotal.totalCourseNumberPerYearOfExtPhd.forEach(
            (tot) => {
              reqtotal += tot;
            }
          );
          otherDeptassignmentcourses.combinationTotal.totalCourseNumberPerYearOfExtPhd.forEach(
            (tot) => {
              othertotal += tot;
            }
          );
        }
      } else if (admissionForReport !== "all" && programForReport === "all") {
        ownassignmentcourses.unassignedCourses.forEach((course) => {
          if (course.course_admission === admissionForReport) {
            filteredOwnCourses.push(course);
          }
        });
        reqassignmentcourses.unassignedCourses.forEach((course) => {
          if (course.course_admission === admissionForReport) {
            filteredReqCourses.push(course);
          }
        });
        otherDeptassignmentcourses.unassignedCourses.forEach((course) => {
          if (course.course_admission === admissionForReport) {
            filteredOtherCourses.push(course);
          }
        });

        if (admissionForReport === "Regular") {
          ownassignmentcourses.separateTotal.totalCourseNumberPerYearofRegular.forEach(
            (tot) => {
              owntotal += tot;
            }
          );
          reqassignmentcourses.separateTotal.totalCourseNumberPerYearofRegular.forEach(
            (tot) => {
              reqtotal += tot;
            }
          );
          otherDeptassignmentcourses.separateTotal.totalCourseNumberPerYearofRegular.forEach(
            (tot) => {
              othertotal += tot;
            }
          );
        } else {
          ownassignmentcourses.separateTotal.totalCourseNumberPerYearofExtension.forEach(
            (tot) => {
              owntotal += tot;
            }
          );
          reqassignmentcourses.separateTotal.totalCourseNumberPerYearofExtension.forEach(
            (tot) => {
              reqtotal += tot;
            }
          );
          otherDeptassignmentcourses.separateTotal.totalCourseNumberPerYearofExtension.forEach(
            (tot) => {
              othertotal += tot;
            }
          );
        }
      } else if (admissionForReport === "all" && programForReport !== "all") {
        ownassignmentcourses.unassignedCourses.forEach((course) => {
          if (course.course_program === programForReport) {
            filteredOwnCourses.push(course);
          }
        });
        reqassignmentcourses.unassignedCourses.forEach((course) => {
          if (course.course_program === programForReport) {
            filteredReqCourses.push(course);
          }
        });
        otherDeptassignmentcourses.unassignedCourses.forEach((course) => {
          if (course.course_program === programForReport) {
            filteredOtherCourses.push(course);
          }
        });
        if (programForReport === "UG") {
          ownassignmentcourses.separateTotal.totalCourseNumberPerYearofug.forEach(
            (tot) => {
              owntotal += tot;
            }
          );
          reqassignmentcourses.separateTotal.totalCourseNumberPerYearofug.forEach(
            (tot) => {
              reqtotal += tot;
            }
          );
          otherDeptassignmentcourses.separateTotal.totalCourseNumberPerYearofug.forEach(
            (tot) => {
              othertotal += tot;
            }
          );
        } else if (programForReport === "Phd") {
          ownassignmentcourses.separateTotal.totalCourseNumberPerYearofphd.forEach(
            (tot) => {
              owntotal += tot;
            }
          );
          reqassignmentcourses.separateTotal.totalCourseNumberPerYearofphd.forEach(
            (tot) => {
              reqtotal += tot;
            }
          );
          otherDeptassignmentcourses.separateTotal.totalCourseNumberPerYearofphd.forEach(
            (tot) => {
              othertotal += tot;
            }
          );
        } else {
          ownassignmentcourses.separateTotal.totalCourseNumberPerYearofmsc.forEach(
            (tot) => {
              owntotal += tot;
            }
          );
          reqassignmentcourses.separateTotal.totalCourseNumberPerYearofmsc.forEach(
            (tot) => {
              reqtotal += tot;
            }
          );
          otherDeptassignmentcourses.separateTotal.totalCourseNumberPerYearofmsc.forEach(
            (tot) => {
              othertotal += tot;
            }
          );
        }
      }
      ownunassigned = filteredOwnCourses.length;
      requnassigned = filteredReqCourses.length;
      otherunassigned = filteredOtherCourses.length;
    }

    setDataOfGeneral({
      own: {
        total: owntotal,
        unassignednum: ownunassigned,
      },
      req: {
        total: reqtotal,
        unassignednum: requnassigned,
      },
      other: {
        total: othertotal,
        unassignednum: otherunassigned,
      },
    });
  }

  useEffect(() => {
    filterReportResult();
  }, [admissionForReport, programForReport]);

  return (
    <ReportContext.Provider
      value={{
        openReport,
        setOpenReport,
        admissionForReport,
        setadmissionForReport,
        programForReport,
        setProgramForReport,
        ownassignmentcourses,
        setownassignmentcourses,
        otherDeptassignmentcourses,
        setotherDeptassignmentcourses,
        reqassignmentcourses,
        setreqassignmentcourses,
        setLoading,
        dataOfGeneral,
        setDataOfGeneral,
        loading,
        getCourseReport,
        filterReportResult,
        showDetailsof,
        setshowDetailsof,
      }}
    >
      {children}
    </ReportContext.Provider>
  );
};

export default ReportContext;
